  <div class="mat-dialog-draggable-main-content mat-dialog-initial">
    <div class="mat-dialog-draggable-header">
      <h2 mat-dialog-title mat-dialog-draggable-title>{{'forward_sign.forward' | translate}}
        <button type="button" class="close" aria-label="Close" (click)="onNoClick()" cdkFocusInitial>
          <span aria-hidden="true">&times;</span>
        </button>
      </h2>
      <mat-divider style="padding-bottom: 1rem;"></mat-divider>
    </div>
    <mat-dialog-content>
      <div *ngIf="initialInfo">
        <mat-card class="example-card" style="padding: 10px">
          <mat-card-header>
            <mat-card-title>{{initialInfo.name}}</mat-card-title>
            <mat-card-subtitle>{{initialInfo.email}} - {{initialInfo.phone}}</mat-card-subtitle>
          </mat-card-header>
        </mat-card>
      </div>
      <div class="popup-content">
        <label>{{'forward_sign.signer' | translate}}</label>
        <nz-input-group [nzSuffix]="suffixUserInput">
          <input nz-input [(ngModel)]="inputUserValue" (input)="onChangeUserSignSearch($event.target.value)"
                 [nzAutocomplete]="autoUserSearching" [ngModelOptions]="{ standalone: true }"
                 placeholder="{{'placeholder.name_and_email' | translate}}"/>
          <nz-autocomplete #autoUserSearching>
            <nz-auto-option *ngFor="let user of filteredUserOptions"
                            (selectionChange)="autocompleteUserSelected($event, user)" [nzValue]="''">{{user.name}}
              - {{user.email}}</nz-auto-option>
          </nz-autocomplete>
        </nz-input-group>
        <ng-template #suffixUserInput>
          <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
        </ng-template>
        <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                            style="font-size: 24px;"></i></ng-template>
      </div>
  
    </mat-dialog-content>
    <div class="w-100 mat-dialog-draggable-footer">
      <mat-dialog-actions align="center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button [disabled]="!isFormChanging" (click)="onClickBtnConfirm()"
                type="button" color="primary">
          <mat-icon class="mr-0">save</mat-icon>
          {{'confirm'| translate}}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
  
  
  